define([
  "app/control/uploader",
  "app/modules/language",
  "app/modules/local_storage",
  "app/modules/forms",
  "app/modules/employmentHistory",
  "app/modules/utilities"
], function(Uploader, Language, LocalStorage, Forms, EmploytmentHistory, Util) {
  const FORM_PREFIX = "user_";

  class Profiles {
    constructor() {
      this.$lookingType = $(".js-profile-looking-type");
      this.$lookingTypeInput = this.$lookingType.find("input");
      this.$lookingTypeModal = $("#js-switch-looking-type");
      this.$generalInfoForm = $(".js-profile-general-info");
      this.$accept = $(".js-confirm-accept");

      this.showModal = this.showModal.bind(this);
      this.handleCloseModal = this.handleCloseModal.bind(this);
      this.handleAccept = this.handleAccept.bind(this);

      LocalStorage.loadForm(
        "user",
        $(".edit-profile-form")
          .attr("action")
          .split("/")[1]
      );
      const uplPhoto = new Uploader($("#user_photo"), { type: "image" });
      const uplResume = new Uploader($("#user_resume"), { type: "file" });
      new EmploytmentHistory({
        resourceName: "user"
      });
      Forms.bindSharedControls();
    }

    actionShow() {
      this.bindEvents();
    }

    actionEdit() {
      this.bindEvents();
    }

    actionUpdate() {
      this.bindEvents();
    }

    bindEvents() {
      $(".add-language").on("click", function(e) {
        e.preventDefault();
        Language.add(null, "user");
      });

      $(".languages-list").on("click", ".remove-language", function(e) {
        e.preventDefault();
        Language.remove($(this));
      });

      $(".general").on("click", ".actions a", () => {
        const inputs = $(this).closest(".info-list");
        if (inputs.find(".fields:visible").length === 1) {
          inputs
            .parent()
            .find("label")
            .text("");
        }
      });

      $(".edit-profile-form").on("submit", function(e) {
        e.preventDefault();
        Forms.submitWithFiles($(this), FORM_PREFIX);
      });

      this.$lookingTypeInput.on("change", this.showModal);
      this.$lookingTypeModal.on("hide.bs.modal", this.handleCloseModal);
      this.$accept.on("click", this.handleAccept);
    }

    handleAccept() {
      this.isAccepted = true;
    }

    showModal({ currentTarget }) {
      if (currentTarget.value === "0" && currentTarget.checked) {
        this.$lookingTypeModal.modal("show");
      }
    }

    handleCloseModal(event) {
      if (this.isAccepted) {
        return Forms.submitWithFiles(this.$generalInfoForm, FORM_PREFIX);
      }

      Forms.toggleSwitcher(this.$lookingType.find(".ca-switcher"), true);
      this.isAccepted = false;
    }
  }

  return Profiles;
});
